import type {User} from '~/types'

type PendoInitializeOptions = {
  visitor?: Record<string, unknown>
  account?: Record<string, unknown>
}

type PendoAgent = {
  initialize: (options: PendoInitializeOptions) => void
  identify?: (...args: unknown[]) => void
  updateOptions?: (...args: unknown[]) => void
  pageLoad?: (...args: unknown[]) => void
  track?: (...args: unknown[]) => void
  _q?: unknown[][]
}

declare global {
  interface Window {
    pendo?: PendoAgent
    __pendoUserId?: string
  }
}

const PENDO_SCRIPT_ID = 'pendo-agent'

const createPendoStub = (apiKey: string) => {
  const script = document.createElement('script')
  script.id = PENDO_SCRIPT_ID
  script.async = true
  script.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`

  const target = document.getElementsByTagName('script')[0]
  target?.parentNode?.insertBefore(script, target)
}

const ensurePendoStub = (apiKey: string) => {
  if (window.pendo) {
    return
  }

  const pendo: PendoAgent = {
    initialize(...args) {
      pendo._q?.push(['initialize', ...args])
    },
    identify: (...args) => {
      pendo._q?.push(['identify', ...args])
    },
    updateOptions: (...args) => {
      pendo._q?.push(['updateOptions', ...args])
    },
    pageLoad: (...args) => {
      pendo._q?.push(['pageLoad', ...args])
    },
    track: (...args) => {
      pendo._q?.push(['track', ...args])
    },
    _q: [],
  }

  window.pendo = pendo

  if (!document.getElementById(PENDO_SCRIPT_ID)) {
    createPendoStub(apiKey)
  }
}

export const initPendo = (apiKey: string) => {
  if (typeof window === 'undefined' || !apiKey) {
    return
  }

  ensurePendoStub(apiKey)
}

export const setUpPendo = (user: User) => {
  if (typeof window === 'undefined') {
    return
  }

  if (!window.pendo || typeof window.pendo.initialize !== 'function') {
    return
  }

  const visitorId = user.dow_jones_user_id

  if (window.__pendoUserId === visitorId) {
    return
  }

  window.__pendoUserId = visitorId

  window.pendo.initialize({
    visitor: {
      id: visitorId,
    },
  })
}
